import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import { HotTable } from '@handsontable/react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import CompliancePopover from './CompliancePopover';
import "../css/handsontable.full.css";

class DataTable extends Component {

    complianceRenderer(instance, td, row, col, prop, value, cellProperties) {
        if (this.props.complianceNotAvailable) {
            const tooltip = (<Tooltip id="compliance-tooltip">
                Resubmit your upload to view compliance results
            </Tooltip>);
            ReactDOM.render((
                <OverlayTrigger trigger={["hover", "focus"]} placement="left" overlay={tooltip}>
                    <div><p style={{ color: '#707070', margin: '0' }}>n/a</p></div>
                </OverlayTrigger>
            ), td);

            return td;
        }

        const assetName = instance.getDataAtCell(row, 0);
        const asset = this.props.jobData.find(asset => asset.asset === assetName);

        const resultsType = (col === 7) ? "WARNING" : "FAILURE";
        const results = (resultsType === "WARNING") ? asset.complianceWarning : ("complianceBlocker" in asset && resultsType === "FAILURE") ? asset.complianceBlocker : asset.compliance;

        if (instance.getDataAtCell(row, col) == 0) {
            ReactDOM.render( <p style={{ color: '#707070', margin: '0' }}>{value}</p> , td);
            return td;
        }
		
        const popover = (
            <CompliancePopover
                asset={assetName}
                assetType={asset.assetType}
                archive={asset.archive}
                engine={asset.engine}
                project={asset.project}
                compliance={results}
				resultsType={resultsType}
            >
            </CompliancePopover>
        );

        const overlayTrigger = (
            <OverlayTrigger trigger="click" placement="left" overlay={popover} rootClose>
                <div><a className='compliance-link' href='#'>{value}</a></div>
            </OverlayTrigger>
        );

        ReactDOM.render(overlayTrigger, td);

        return td;
    }

    shouldComponentUpdate(nextProps){
        let jobData = this.props.jobData
        if (this.refs.hot && nextProps.selected !== this.props.selected){
            let jobs = this.refs.hot.hotInstance.getData(jobData.length - 1, 0).map(item => item[0]);
            this.refs.hot.hotInstance.selectCell(jobs.indexOf(nextProps.selected), 0)
        }
        return false;
    }

    render() {
		
		let columnNames = null;
		let tableData = null;
		let resultCols = [];
		
		if (typeof this.props.jobData.compliance === "undefined") {
	        columnNames = [
	            "Asset Name",
	            "Asset Type",
	            "Complexity Rating",
	            "Transformer LOC",
	            "Stage Type",
	            "Cyclomatic",
	            "Compliance Blockers",
	            "Compliance Warnings",
	            "Archive",
	            "Engine",
	            "Project"
	        ];
	
			resultCols.push(6);
			resultCols.push(7);
			
	        tableData = this.props.jobData.map(asset => {
	            let failedComplianceBlockers = 0;
                let failedComplianceWarnings = 0;
    
                if ("complianceBlocker" in asset) {
                    for (let c of asset.complianceBlocker) {
                        if (c.result === "FAILURE" || c.result === "ERROR") failedComplianceBlockers++;
                    }
                }

                if ("complianceWarning" in asset) {
                    for (let c of asset.complianceWarning) {
                        if (c.result === "FAILURE" || c.result === "ERROR") failedComplianceWarnings++;
                    }
                }
	
	            return [
	                asset.asset,
	                asset.assetType,
	                asset.complexityScore.total,
	                asset.complexityScore["Transformer LOC"],
	                asset.complexityScore["Stage Type"],
	                asset.complexityScore["Cyclomatic"],
	                failedComplianceBlockers,
					failedComplianceWarnings,
	                asset.archive,
	                asset.engine,
	                asset.project
	            ];
	        });
		} else {
	        columnNames = [
	            "Asset Name",
	            "Asset Type",
	            "Complexity Rating",
	            "Transformer LOC",
	            "Stage Type",
	            "Cyclomatic",
	            "Compliance Issues",
	            "Archive",
	            "Engine",
	            "Project"
	        ];
	
			resultCols.push(6);
				
	        tableData = this.props.jobData.map(asset => {
				let totalComplianceRules = 0;
	            let failedComplianceRules = 0;
								
	            for (let c of asset.compliance) {
					totalComplianceRules++;
	                if (c.result === "FAILURE" || c.result === "ERROR") failedComplianceRules++;
	            }
	
	            return [
	                asset.asset,
	                asset.assetType,
	                asset.complexityScore.total,
	                asset.complexityScore["Transformer LOC"],
	                asset.complexityScore["Stage Type"],
	                asset.complexityScore["Cyclomatic"],
	                failedComplianceRules,
	                asset.archive,
	                asset.engine,
	                asset.project
	            ];
	        });			
		}


        return (
            <HotTable id="reportTable"
                ref="hot"
                readOnly={true}
                outsideClickDeselects={false}
                selectionMode="single"
                data={tableData}
                columnSorting={true}
                currentRowClassName="currentReportRow"
                colHeaders={columnNames}
                rowHeaders={true}
                stretchH="all"
                copyable={false}
                afterColumnSort = {() => {
                    this.props.newSelection(this.refs.hot.hotInstance.getDataAtRow(0)[0]);
                }}
                afterSelection= {(row, col, row2, col2) => {
                    this.props.newSelection(this.refs.hot.hotInstance.getDataAtRow(row)[0]);
                    var meta = this.refs.hot.hotInstance.getCellMeta(row2, col2);
                    if (!meta.editor) {
                        this.refs.hot.hotInstance.updateSettings({
                            fillHandle: false
                        });
                    } else {
                        this.refs.hot.hotInstance.updateSettings({
                            fillHandle: true
                        });
                    }
                }}
                afterOnCellCornerDblClick={() => {return}}
                cells={(row, col) => {
                    let cellProperties = {};
                    if (resultCols.includes(col)) {
                        cellProperties.renderer = this.complianceRenderer.bind(this)
                    }

                    return cellProperties;
                }}
            />

        );
    }
};

export default DataTable;
